import React, { useEffect, useState } from "react";
import ThemedLoader from 'components/atoms/ThemedLoader'
import i18n from "utils/i18n";
import HelperString from 'utils/helper-string'
import FetchTimeslotGroups from 'utils/fetch/FetchTimeslotGroups'
import ManagementGroupedThemeList from 'components/management/molecules/ManagementGroupedThemeList'
import { constantsActive } from 'utils/constants/constants'
import ManagementHeader from 'components/management/molecules/ManagementHeader'
import _ from 'lodash'
import HelperManagementRights from 'utils/helper-management-rights'
import { managementRightsConstants } from 'utils/constants/management-right-constants'
import Translate from 'utils/translate'
import { listArrow } from 'styles/list'
import { AppRoutes } from 'navigations/app-routes'
import { useIsFocused, useNavigation } from '@react-navigation/native'
import ThemedBlock from 'components/atoms/ThemedBlock'
import { View } from 'react-native'
import DraggableFlatList from 'react-native-draggable-flatlist'
import ThemedDivider from 'components/atoms/ThemedDivider'
import GraphqlBuilder from 'utils/request/graphql/builder'
import MutationManagementTimeslotGroupPositions from 'graphql/mutations/management/MutationManagementTimeslotGroupPositions'
import { layoutStyles } from 'styles/layout'
import ListItem from 'components/atoms/ListItem'

const ManagementTimeslotsIndexTabTimeslotGroups = () => {
	const navigation = useNavigation();
	const isFocused = useIsFocused();
	
	const [ timeslotGroups, setTimeslotGroups ] = useState( [] );
	const [ isLoading, setIsLoading ] = useState( false );
	const [ search, setSearch ] = useState('')
	const [ draggable, setDraggable ] = useState( false )
	const [ savingDraggable, setSavingDraggable ] = useState( false )
	const [ changedTimeslotGroups, setChangedTimeslotGroups ] = useState( [] )
	
	const loading = () => {
		setIsLoading(true);
	}
	const loaded = () => {
		setIsLoading(false);
	}
	
	
	const fetchedTimeslotGroups = ( timeslotGroups ) => {
		setTimeslotGroups( timeslotGroups );
		loaded();
	}
	
	const fetchTimeslotGroups = () => {
		if( !isLoading ){
			FetchTimeslotGroups.fetchAll({
				callbackStart: loading,
				callbackError: loaded,
				callbackSuccess: fetchedTimeslotGroups
			} );
		}
	}
	
	useEffect( () => {
		fetchTimeslotGroups();
	}, [] );
	
	useEffect( () => {
		if( isFocused ) {
			fetchTimeslotGroups();
		}
	}, [ isFocused ] );
	
	const openTimeslotGroup =  ( timeslotGroup ) => {
		navigation.navigate( AppRoutes.MANAGEMENT_TIMESLOT_GROUPS, {
			timeslotGroupGuid: timeslotGroup.guid
		} );
	}
	
	const createTimeslotGroup = () => {
		openTimeslotGroup( {} );
	}
	
	const renderItem = ( { item, index } ) => {
		return (
			<ListItem
				title={ Translate.field( item, 'name' ) }
				title_add_active_tag={ true }
				item={ item }
				accessoryRight={ listArrow }
				onPress={ openTimeslotGroup }
			/>
		)
	}
	
	const renderDraggableItem = ( { item, index, drag, isActive } ) => {
		return (
			<ListItem
				title={ Translate.field( item, 'name' ) }
				title_add_active_tag={ true }
				item={ item }
				drag={ drag }
				dragIsActive={ isActive }
			/>
		)
	}
	
	const toggleDraggable = () => {
		setDraggable( !draggable )
	}
	
	const mutationTimeslotGroupPositions = () => {
		const variables = {};
		variables['timeslot_group_positions'] = _.map( changedTimeslotGroups, (timeslotGroup, key) => {
			return (
				{
					timeslot_group_guid: timeslotGroup.guid,
					position: key
				}
			);
		})
		
		new GraphqlBuilder()
			.addQuery( 'mutation_timeslot_group_position', MutationManagementTimeslotGroupPositions, variables )
			.setOnStart( setSavingDraggable.bind( this, true ) )
			.setOnError( setSavingDraggable.bind( this, false ) )
			.setOnSuccess( result => {
				setSavingDraggable( false )
				setDraggable( false )
				fetchTimeslotGroups();
			})
			.execute()
	}
	
	const header = (
		<ManagementHeader
			inputs={[
				{
					placeholder: i18n.t( 'management:form.search.title'),
					onChangeText: _.debounce( setSearch, 400 )
				}
			]}
			dragButton={ HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.TIMESLOTS ) ? {
				onPress: toggleDraggable.bind( this ),
				drag: draggable,
				save: mutationTimeslotGroupPositions.bind( this ),
				isSaving: savingDraggable
			} : null}
			addButton={ HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.TIMESLOTS ) ? { onPress: createTimeslotGroup } : null }
		/>
	);
	
	const content = [];
	
	const filters = _.size( search ) > 2 ? [ {field: 'name', kind: 'contains', value: search } ] : null;
	
	switch( true ) {
		case isLoading:
			content.push(
				<ThemedLoader
					key={ HelperString.hash('coworker-tab-coworker-loading-members') }
					text={ i18n.t( 'loading.timeslot_groups' ) }
				/>
			);
			break;
		case draggable:
			
			content.push(
				<ThemedBlock
					header={ header }
					shadow>
					
					<View style={ layoutStyles.flexOne }>
						<DraggableFlatList
							data={ _.filter( !_.isEmpty( changedTimeslotGroups ) ? changedTimeslotGroups : timeslotGroups, { active: constantsActive.YES } ) }
							renderItem={ renderDraggableItem.bind( this ) }
							ItemSeparatorComponent={ ThemedDivider }
							keyExtractor={ (item, index) => {
								return HelperString.hash(`draggable-item`, item.guid);
							} }
							onDragEnd={ ({ data }) => {
								return setChangedTimeslotGroups(data);
							} }
						/>
					</View>
				</ThemedBlock>
			)
			break;
		default:
			content.push(
				<ManagementGroupedThemeList
					header={ header }
					items={ timeslotGroups }
					renderItem={ renderItem.bind( this ) }
					groupByKey={ 'active' }
					filters={ filters }
					groupByValues={ [
						constantsActive.YES,
						constantsActive.NO
					] }
				/>
		);
	}
	
	return content
}

export default ManagementTimeslotsIndexTabTimeslotGroups;
